export default __webpack_public_path__ + "static/media/prize-3-cn.3fbd1b40.webp";